module.exports = __webpack_public_path__ + "static/media/prop-71.04502908.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/props/images/prop-71.png
// module id = 628
// module chunks = 0 32 33 34